export function ErrorSlide() {
  return (
    <div className='flex flex-col h-full w-full items-center overflow-clip px-[204px] py-0'>
      {/* Modal Header */}
      <div className='flex flex-col items-end pb-0 pt-[60px] px-0 w-full'>
        <div className='flex flex-col gap-[16px] items-center w-full'>
          <p className="font-['Geist'] font-bold text-[20px] leading-[22px] text-black">
            Error in running task
          </p>
          <p className="font-['Geist'] font-medium text-[14px] leading-[22px] text-[rgba(0,0,0,0.65)] text-center">
            There is a temporary error in running the task. Please try again.
          </p>
        </div>
      </div>
    </div>
  )
}
